import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { HashLink as RouterLink } from 'react-router-hash-link';

import UpdateRequiredContext from 'containers/UpdateRequiredContext';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const BaseLink = ({
  component,
  to,
  ...props
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ComponentType<any>;
  to?:
    | string
    | {
        pathname: string;
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        state?: Record<string, any>;
      };
}) => {
  const Component = component;
  const isStateless =
    typeof to === 'string' || (typeof to === 'object' && !to.state);
  return (
    <UpdateRequiredContext.Consumer>
      {(updateRequired) =>
        updateRequired && isStateless ? (
          /* eslint-disable jsx-a11y/anchor-has-content */
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | { pathname: string; state?: Record<... Remove this comment to see the full error message
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/jsx-props-no-spreading
          <a href={to} {...props} />
        ) : (
          /* eslint-enable jsx-a11y/anchor-has-content */
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Component to={to} {...props} />
        )
      }
    </UpdateRequiredContext.Consumer>
  );
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition, @typescript-eslint/no-explicit-any
export const NavLink = (props: any) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <BaseLink component={RouterNavLink} {...props} />
);
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition, @typescript-eslint/no-explicit-any
export const Link = (props: any) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <BaseLink component={RouterLink} {...props} />
);
